<template>
  <div class="other">
    <drag-modal :visible="$store.state.dislog.Other" @cancel="reset"
      :title='info.id ? `${see ? "查看" : "修改"}${form.titles}信息` : "添加当事人信息"' width='660px'>
      <a-form-model ref="forms" :model="form" :rules="rules" :validate-on-rule-change="false" :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }" class="otherform">
        <a-form-model-item label="当事人类型" prop="state">
          <a-select v-model="form.state" placeholder="请选择" :disabled='(isEdit(form.audit, "state") || see || form.id)'
            :class='{ "yellow": isEdit(form.audit, "state") }' @change="onTypeChange">
            <a-select-option :value="1">{{ i.cause_type == 1 ? '原告' : '申请人' }}</a-select-option>
            <a-select-option :value="2">{{ i.cause_type == 1 ? '被告' : '被申请人' }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="主体类型" prop="type">
          <a-select v-model="form.type" placeholder="请选择" :disabled='isEdit(form.audit, "type") || see'
            :class='{ "yellow": isEdit(form.audit, "type") }' @change="onTypeChange">
            <a-select-option :value="2">企业</a-select-option>
            <a-select-option :value="1">个人</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="层级" prop="is_main" v-if="form.state == 1">
          <a-select v-model="form.is_main" placeholder="请选择" :disabled='isEdit(form.audit, "is_main") || see'
            :class='{ "yellow": isEdit(form.audit, "is_main") }'>
            <a-select-option :value="1">主要</a-select-option>
            <a-select-option :value="0">共同</a-select-option>
          </a-select>
        </a-form-model-item>
        <div v-if="form.state == 1 && form.type == 1">
          <a-form-model-item label="挂靠企业名称" prop="accuser_id">
            <a-select v-model="form.accuser_id" placeholder="请选择企业名称" @change="ChangeName(form.accuser_id, '个人')">
              <a-select-option v-for="item in accuserList" :key="item.id" :value="item.id">{{
                item.realname
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="姓名" prop="plaintiff_id" v-if="form.type == 1">
            <a-select v-model="form.plaintiff_id" placeholder="请选择姓名" @change="ChangeName1(form.plaintiff_id)">
              <a-select-option v-for="item in plaintiff" :key="item.id" :value="item.id">{{
                item.realname
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </div>
        <div v-if="form.state == 1 && form.type == 2">
          <a-form-model-item label="企业名称" prop="plaintiff_id">
            <a-select v-model="form.plaintiff_id" :disabled='isEdit(form.audit, "realname") || see'
              placeholder="请选择企业名称" @change="ChangeName(form.plaintiff_id, '企业')">
              <a-select-option v-for="item in accuserList" :key="item.id" :value="item.id">{{
                item.realname
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </div>
        <a-form-model-item :label="form.type == 1 ? '姓名' : '企业名称'" prop="realname" v-if="form.state == 2">
          <a-input v-model="form.realname" :disabled='isEdit(form.audit, "realname") || see'
            :placeholder="form.type == 1 ? '请输入姓名' : '请输入企业名称'" :class='{ "yellow": isEdit(form.audit, "realname") }' />
        </a-form-model-item>
        <a-form-model-item :label="form.type == 1 ? '证件号码' : '统一社会信用代码'" prop="chinaid">
          <a-input v-model="form.chinaid" :maxLength="18" :disabled='isEdit(form.audit, "chinaid") || see'
            :placeholder="form.type == 1 ? '请输入证件号码' : '请输入统一社会信用代码'"
            :class='{ "yellow": isEdit(form.audit, "chinaid") }' @blur="getSex(form.chinaid, form.type)"
            @change="getSex(form.chinaid, form.type)" />
        </a-form-model-item>
        <a-form-model-item label="联系方式" prop="phone" v-if="form.state == 2">
          <a-input v-model="form.phone" :maxLength="20" :disabled='isEdit(form.audit, "phone") || see'
            placeholder="请输入联系方式" :class='{ "yellow": isEdit(form.audit, "phone") }' />
        </a-form-model-item>
        <a-form-model-item label="关系：" prop="relation"
          v-if="form.state == 2 && form.relation != 1 && form.titles != '原告'">
          <a-select v-model="form.relation" placeholder="请选择" style="width:160px;"
            :class='{ "yellow": isEdit(form.audit, "relation") }' :disabled='isEdit(form.audit, "relation") || see'>
            <a-select-option :value="2">共同债务人-配偶</a-select-option>
            <a-select-option :value="5">共同债务人-其他</a-select-option>
            <a-select-option :value="3">连带担保人-配偶</a-select-option>
            <a-select-option :value="4">连带担保人-其他</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="性别：" prop="sex" v-if='form.type == 1'>
          <a-select v-model="form.sex" placeholder="请选择" style="width:160px;"
            :class='{ "yellow": isEdit(form.audit, "sex") }' :disabled='isEdit(form.audit, "sex") || see'>
            <a-select-option :value="1">男</a-select-option>
            <a-select-option :value="2">女</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="form.type == 1 ? '户籍地' : '注册地'" prop="citys" v-if="form.state == 2">
          <a-cascader :options="options" placeholder="请选择"
            :field-names="{ label: 'full_name', value: 'full_name', children: 'more' }" v-model='form.citys'
            :class='{ "yellow": isEdit(form.audit, "province,city,area") }'
            :disabled='isEdit(form.audit, "province,city,area") || see' @change="citysCg" />
          <a-input v-model="form.addr" type='textarea' style="margin-top:20px;" placeholder="请输入详细地址"
            :class='{ "yellow": isEdit(form.audit, "addr") }' :disabled='isEdit(form.audit, "addr") || see'
            @blur="AddCg" />
        </a-form-model-item>
        <a-form-model-item :label="form.type == 1 ? '常住地' : '办公地'" prop="dwell" v-if="form.state == 2">
          <a-cascader :options="options" placeholder="请选择"
            :field-names="{ label: 'full_name', value: 'full_name', children: 'more' }" v-model='form.dwell'
            :disabled='isEdit(form.audit, "dwell_province,dwell_city,dwell_area") || see'
            :class='{ "yellow": isEdit(form.audit, "dwell_province,dwell_city,dwell_area") }' />
          <a-input v-model="form.dwell_addr" type='textarea' style="margin-top:20px;" placeholder="请输入详细地址"
            :disabled='isEdit(form.audit, "dwell_addr") || see'
            :class='{ "yellow": isEdit(form.audit, "dwell_addr") }' />
        </a-form-model-item>
        <a-form-model-item label="备注：" prop="comment" v-if="form.state == 2">
          <a-input v-model="form.comment" type='textarea' placeholder="备注"
            :disabled='isEdit(form.audit, "comment") || see' :class='{ "yellow": isEdit(form.audit, "comment") }' />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }" v-if='!see'>
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='confirm(info.id)'>
            <a-button type="primary" style="width:148px;margin-right:20px;">
              提交
            </a-button>
          </a-popconfirm>
          <a-button style='background:#B2C9E1;color:#fff;width:148px;' @click='reset'>取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </drag-modal>
  </div>
</template>
<script>
import city from "@/assets/js/city.json"
import Validator from "@/assets/js/yz.js"
import { debtorOther, getclient } from "@/server/debtor"
import { accuseList } from '@/server/api'
import { citySort } from '@/assets/js/unit'
export default {
  name: 'Other',
  props: {
    info: {
      type: Object,
      default() {
        return {
          audit: []
        }
      }
    },
    see: {
      type: Boolean,
      default: false
    },
    i: Object,
    accuserList: Array
  },
  data() {
    // 自定义验证函数
    const validateChinaId = (rule, value, callback) => {
      if (!value) {
        const msg = this.form.type == 2 ? '请输入统一社会信用代码' : '请输入证件号码';
        callback(new Error(msg));
        return;
      }
      // 身份证验证规则
      const idCardPattern = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
      // 统一社会信用代码验证规则
      const creditCodePattern = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;

      // 检查是否符合身份证格式
      const isIdCard = idCardPattern.test(value);
      // 检查是否符合统一社会信用代码格式
      const isCreditCode = creditCodePattern.test(value);

      // 如果两种格式都不符合，返回错误
      if (!isIdCard && !isCreditCode) {
        callback(new Error('请输入有效的证件号码'));
      } else {
        callback();
      }
    };
    return {
      options: citySort(city),
      visible: false,
      rules: {
        state: [{ required: true, message: '请选择当事人类型', trigger: 'change' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        is_main: [{ required: true, message: '请选择层级', trigger: 'change' }],
        realname: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              const msg = this.form.type == 2 ? '请输入企业名称' : '请输入姓名';
              callback(new Error(msg));
            } else {
              callback();
            }
          }, trigger: ['blur', 'change']
        }],
        plaintiff_id: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              const msg = this.form.type == 2 ? '请选择企业名称' : '请选择姓名';
              callback(new Error(msg));
            } else {
              callback();
            }
          }, trigger: 'change'
        }],
        accuser_id: [{ required: true, message: '请选择挂靠企业名称', trigger: 'change' }],
        chinaid: [
          { required: true, trigger: 'blur', validator: validateChinaId, trigger: ['blur', 'change'] }
        ],  //validator: Validator.chinaid 
        phone: [{ required: true, trigger: 'blur', message: '请输入联系方式', }, { validator: Validator.validateContact, trigger: ['blur', 'change'] }],
        sex: [{ required: true, trigger: 'change', message: '请选择被告性别' }],
        relation: [{ required: true, trigger: 'change', message: '请选择关系' }],
        citys: [{ required: true, trigger: 'change', message: '请选择地址' }],
        dwell: [{ required: true, trigger: 'change', message: '请选择地址' }]
      },
      form: {
        realname: null,
        chinaid: null,
        phone: null,
        sex: 1,
        relation: null,
        type: 2,
        state: 1,
        is_main: 0,
        accuser_id: null,
        plaintiff_id: null,
        citys: [],
        dwell: [],
        dwell_addr: '',
        comment: '',
        addr: '',
        titles: '当事人',
        title: '',
      },
      plaintiff: [],
      // accuserList: props.accuserList
    }
  },
  watch: {
    info: {
      handler(newVal) {
        if (newVal.id) {
          this.form = {
            citys: [newVal.province, newVal.city, newVal.area],
            dwell: newVal.dwell_province ? [newVal.dwell_province, newVal.dwell_city, newVal.dwell_area] : [newVal.province, newVal.city, newVal.area],
            dwell_addr: newVal.dwell_addr,
            comment: newVal.comment,
            addr: newVal.addr,
            chinaid: newVal.chinaid,
            realname: newVal.realname,
            accuser_id: newVal.accuser_id,
            plaintiff_id: newVal.id,
            phone: newVal.phone,
            sex: newVal.sex,
            relation: newVal.relation,
            type: newVal.type,//类型
            titles: newVal.titles,
            title: newVal.title,
            audit: [],
            is_main: newVal.is_main ? newVal.is_main : 0,
            state: newVal.state,
            id: newVal.id
          }
        }
        else {
          this.form = {
            citys: newVal.city || [],
            dwell: newVal.dwell || [],
            dwell_addr: newVal.dwell_addr || '',
            comment: newVal.comment,
            addr: newVal.addr || '',
            chinaid: '',
            realname: '',
            phone: '',
            sex: 1,
            relation: '',
            titles: '当事人',
            title: '',
            type: 2,
            state: 1,
            is_main: 0
          }
        }
      },
      deep: true,
      immediate: true,
      see: {
        handler(newVal) {
        },
        immediate: true
      }
    }
  },
  created() {
  },
  methods: {
    onTypeChange() {
      this.$refs.forms.clearValidate()
      if (this.form.type == 1) {
        this.form.plaintiff_id = null
        this.form.accuser_id = null
        this.form.chinaid = null
        this.form.sex = null
      }

    },
    ChangeName(item, type) {
      this.form.chinaid = null
      this.accuserList.map((res) => {
        if (res.id == item) {
          if (type == '个人') {
            this.plaintiff = res.debtors
          } else {
            if (this.form.type == 2) {
              this.form.chinaid = res.chinaid
            }
          }
        }
      })
    },
    ChangeName1(item) {
      if (this.form.type == 1) {
        this.plaintiff.map((res) => {
          if (res.id == item) {
            this.form.chinaid = res.chinaid
            this.getSex(res.chinaid)
          }
        })
      }
    },
    AddCg(val) {
      if (this.form.dwell_addr.length == 0) {
        this.form.dwell_addr = this.form.addr
      }
    },
    getSex(UUserCard, type) {
      this.form.sex = '';
      if (type == 1) {
        // 身份证必须存在 && 长度15或18位
        if (!UUserCard || ![15, 18].includes(UUserCard.length)) {
          this.form.sex = ''; // 不合法就为空
          return;
        }

        let sexCode;
        if (UUserCard.length === 18) {
          // 18位身份证：第17位（下标16）是性别位 ✅
          sexCode = UUserCard.substr(16, 1);
        } else {
          // 15位身份证：最后1位是性别位
          sexCode = UUserCard.substr(14, 1);
        }

        // 奇数=男(1)，偶数=女(2)
        this.form.sex = parseInt(sexCode) % 2 === 1 ? 1 : 2;
      }
    },
    isEdit(Arr, val) {
      // if (Arr) {
      //   let bool = Arr.filter(ele => {
      //     return val.split(",").indexOf(ele.field) >= 0
      //   }).length > 0 ? true : false;
      //   return bool
      // }
    },
    citysCg(val) {
      if (this.form.dwell.length == 0) {
        this.form.dwell = val
      }
    },
    confirm(id) {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form));
          form.province = form.citys[0];
          form.city = form.citys[1];
          form.area = form.citys[2];
          if (form.dwell.length > 0) {
            form.dwell_province = form.dwell[0];
            form.dwell_city = form.dwell[1];
            form.dwell_area = form.dwell[2];
            delete form.dwell
          }
          delete form.citys
          form.debtor_id = this.$route.params.id
          if (id) {
            form.id = id
          }
          if (form.state == 1) {
            delete form.relation
            delete form.realname
          }
          if (form.is_main == 1) {
            delete form.relation
          }
          form.cause_id = this.$store.state.cause.id
          getclient(id, form).then(e => {
            if (id) {
              if (e.audit && e.audit > 0) {
                this.$message.success({ content: '已提交审核', key: 'updatable' });
              } else {
                this.$message.success({ content: '修改成功', key: 'updatable' });
              }
            } else {
              this.$message.success({ content: '新增成功', key: 'updatable' });
            }
            this.$store.dispatch('Case/getlist', { debtor_id: this.$route.params.id })
            this.reset()
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset() {


      this.$refs.forms.resetFields();
      this.$emit('resh')
      this.$store.dispatch('openkey', { key: 'Other', by: false })
    },
  },
}
</script>
<style lang="less">
.otherform .yellow {
  border: 1px solid #ff9800 !important;
  opacity: 1;
  color: #ccc;
  /* border: 0 none; */
  background: none;
}
</style>